import React, { FC } from "react"
import styled from "styled-components"
import promoImage from "../../../static/images/lp-lk-img-1.png"
import InputComponent from "../../../components/ui/input-form"
import "./style.sass"

const StyledPromo = styled.div`
  display: flex;
  justify-content: space-between;
  max-width: 1220px;
  margin: 0 auto;

  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
`

const Promo: FC = () => {
  return (
    <div className="promo">
      <StyledPromo>
        <div className="promo-form">
          <h2>
            Управляйте договорами
            <br />
            в личном кабинете
            <br />
            для юридических лиц
          </h2>
          <p>Подпишитесь на уведомление о запуске личного кабинета</p>
          <InputComponent className="promo-form__input" />
        </div>
        <div>
          <img src={promoImage} alt="promo-image" />
        </div>
        <InputComponent className="promo-form__input_mobile" />
      </StyledPromo>
    </div>
  )
}

export default Promo
